import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './InfoPages.css';

function OlxPeople() {
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>The ClubLoop Team</h1>
          <p>
            Meet the people behind ClubLoop — the golfers, engineers, and support specialists
            building India's most trusted pre-owned equipment community[cite: 5, 11].
          </p>
        </div>

        <div className="infoSection">
          <h2>Our Culture</h2>
          <p>
            We believe in complete transparency, structural protection, and keeping premium equipment
            moving[cite: 16, 40, 168]. Our engineering, operations, inspection, and community teams work
            collaboratively to deliver a mobile-first platform that simplifies buying and selling straight from the course[cite: 77, 123].
          </p>
        </div>

        <div className="infoSection">
          <h2>Our Core Focus Areas</h2>
          <p>
            Our specialized teams combine deep knowledge of golf equipment parameters with advanced digital
            marketplace mechanics to ensure safe transactions across the country[cite: 16, 59].
          </p>
          <div className="infoGrid">
            <div className="infoCard">
              <h3>Product & Technology</h3>
              <p>
                Developing a fast, mobile-responsive frontend and secure transactional infrastructure integrated with Razorpay[cite: 91, 126, 154].
              </p>
            </div>
            <div className="infoCard">
              <h3>Valuation & Inspection</h3>
              <p>
                Enforcing our strict quality grading metrics (A+ to C) so players can buy with absolute peace of mind[cite: 16, 40].
              </p>
            </div>
            <div className="infoCard">
              <h3>Escrow Operations</h3>
              <p>
                Managing our secure peer-to-peer payment holding loops to protect both buyers and sellers[cite: 29, 113].
              </p>
            </div>
          </div>
        </div>

        <div className="infoSection">
          <h2>Get in Touch</h2>
          <p>
            Our community is united by a shared mission to make high-quality golf gear accessible to men,
            women, and growing junior players across India.
          </p>
          <p>
            Have questions for the team or looking to collaborate? Reach out to <strong>Loki</strong> directly
            via our <Link to="/contact" className="infoLink">Contact Us</Link> page, or explore active opportunities on
            our <Link to="/careers" className="infoLink">Careers</Link> track.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default OlxPeople;
